import { FontAwesomeIcon, FontAwesomeIconProps } from '@fortawesome/react-fontawesome'
import React from 'react'
import { gray8 } from '../../themes/theme'

type ChipListProps = {
  tags: { name: string; iconProps?: FontAwesomeIconProps }[]
}

export const ChipList = React.memo<ChipListProps>(({ tags }) => {
  return (
    <div className="mb-2 mt-1 flex w-max flex-row space-x-2">
      {tags.map((tag, idx) => (
        <div
          key={`${tag.name}-${idx}`}
          className="flex items-center gap-2 rounded-md border border-solid border-bz-gray-500 bg-bz-gray-100 px-3 py-1"
        >
          {tag.iconProps && <FontAwesomeIcon size="sm" color={gray8} {...tag.iconProps} />}
          <span className="text-xs font-normal ">{tag.name}</span>
        </div>
      ))}
    </div>
  )
})

ChipList.displayName = 'ChipList'
